import { FileIcon } from "@untitledui/file-icons";
import type { DocumentType } from "@/types/container";

interface FileTypeIconProps {
    type: DocumentType | string;
    fileName?: string; // Nome del file per estrarre l'estensione
    mimeType?: string; // MIME type per determinare l'estensione
    className?: string;
    size?: "sm" | "md" | "lg";
}

const getFileExtension = (type: DocumentType | string, fileName?: string, mimeType?: string): string => {
    // Se abbiamo il MIME type, usiamolo per determinare l'estensione
    if (mimeType) {
        const mimeToExt: Record<string, string> = {
            "application/pdf": "pdf",
            "image/png": "png",
            "image/jpeg": "jpg",
            "image/jpg": "jpg",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
            "application/vnd.ms-excel": "xls",
        };
        const ext = mimeToExt[mimeType];
        if (ext) {
            return ext;
        }
    }

    // Se abbiamo il nome del file, estraiamo l'estensione da lì
    if (fileName) {
        const ext = fileName.split('.').pop()?.toLowerCase();
        if (ext) {
            return ext;
        }
    }

    // Fallback: mappa i tipi di documento alle estensioni (default PDF)
    const typeMap: Record<string, string> = {
        bill_of_lading: "pdf",
        invoice: "pdf",
        phytosanitary_certificate: "pdf",
        movement_certificate: "pdf",
        packing_list: "pdf",
        fumigation_certificate: "pdf",
        sad_icm: "pdf",
        coo: "pdf",
        unknown: "pdf",
    };

    return typeMap[type] || "pdf";
};

const sizeClasses = {
    sm: "size-4",
    md: "size-6",
    lg: "size-8",
};

export const FileTypeIcon = ({ type, fileName, mimeType, className = "", size = "md" }: FileTypeIconProps) => {
    const extension = getFileExtension(type, fileName, mimeType);
    const sizeClass = sizeClasses[size];

    return (
        <div className={`${sizeClass} ${className}`}>
            <FileIcon type={extension as any} variant="default" className="size-full" />
        </div>
    );
};

